angular.module('ikeweb.spike.report').controller('ReportController', [
    '$scope',
    '$rootElement',
    '$stateParams',
    '$analytics',
    'spikeCaptureService',
    'unitService',
    'measurementService',
    'captureSharingService',
    'events',
    'captureExportService',
    'zoomServiceFactory',
    'printService',
    function($scope,
        $rootElement,
        $stateParams,
        $analytics,
        $spikeCaptureService,
        unitService,
        measurementService,
        captureSharingService,
        EVENTS,
        captureExportService,
        zoomServiceFactory,
        printService) {

        var zoomService = zoomServiceFactory.create();
        var zoomArea,
            capture,
            measurements,
            note,
            shareURL;

        function createExportImage(captureImage) {
            var image = document.createElement('img');
            image.src = URL.createObjectURL(captureImage.getData());
            image.className = 'pages-report-exportImage';
            return image;
        }

        function trackExport(exportType, capture) {
            var event = {
                category: 'Export',
                action: exportType,
                label: capture && capture.id,
                value: 1
            };
            $analytics.eventTrack(exportType, event);
        }

        function createExportReport() {
            var $reportPageClone = $rootElement.find('.pages-report-page').clone();
            var eventType = (capture.note != null && capture.note !== '') ? 'PDFWithNote' : 'PDF';
            trackExport(eventType, capture);
            return captureExportService
                .imageWithMeasurements(capture, zoomArea.serialize())
                .then(createExportImage)
                .then(function(exportImage) {
                    $reportPageClone
                        .find('.pages-report-compositeImage')
                        .replaceWith(exportImage);
                    return $reportPageClone;
                });
        }

        function print() {
            createExportReport()
                .then(printService.printElement);
        }

        function download() {
            $scope.$broadcast(EVENTS.EXPORT.DISPLAY_EXPORT_SELECTOR);
        }

        function imageExport(fn) {
            if (zoomService.getZoom() !== 0) {
                return fn(capture, zoomArea.serialize())
                    .then(captureExportService.download);
            }
            return fn(capture)
                .then(captureExportService.download);
        }

        function shareCaptureURL() {
            return captureSharingService.shareCapture(capture, unitService.getUnit(), zoomArea.serialize())
                .then(function(URL) {
                    shareURL = URL;
                    $scope.$broadcast(EVENTS.SHARING.DISPLAY_SHARE_URL);
                });
        }

        function setZoomArea(value) {
            zoomArea = value;
        }

        function getCapture() {
            return capture;
        }

        function getMeasurements() {
            return measurements;
        }

        function getNote() {
            return note;
        }

        function getShareURL() {
            return shareURL;
        }

        function init() {
            $scope.$on(EVENTS.EXPORT.DOWNLOAD.COMPOSITE, function() {
                imageExport(captureExportService.imageWithMeasurements);
                $scope.$broadcast(EVENTS.EXPORT.DISMISS_EXPORT_SELECTOR);
            });

            $scope.$on(EVENTS.EXPORT.DOWNLOAD.DESKEWED, function() {
                imageExport(captureExportService.deskewed);
                $scope.$broadcast(EVENTS.EXPORT.DISMISS_EXPORT_SELECTOR);
            });

            $scope.$on(EVENTS.EXPORT.DOWNLOAD.IMAGEONLY, function() {
                imageExport(captureExportService.imageOnly);
                $scope.$broadcast(EVENTS.EXPORT.DISMISS_EXPORT_SELECTOR);
            });


            $spikeCaptureService.getCapture($stateParams.spikeid)
                .then(function(value) {
                    capture = value;
                    measurements = measurementService.createMeasurementsFromStorage(capture.measurements);
                    note = capture.note;
                    return capture;
                });
        }

        this.print = print;
        this.download = download;
        this.shareCaptureURL = shareCaptureURL;
        this.setZoomArea = setZoomArea;
        this.zoomIn = zoomService.zoomIn;
        this.zoomOut = zoomService.zoomOut;
        this.getZoom = zoomService.getZoom;
        this.setZoom = zoomService.setZoom;
        this.setViewPortScaleFactor = zoomService.setViewPortScaleFactor;
        this.getCapture = getCapture;
        this.getMeasurements = getMeasurements;
        this.getNote = getNote;
        this.getShareURL = getShareURL;

        init();
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/report/report.controller.js
// module id = 576
// module chunks = 0